import { FontAwesome5 } from '@expo/vector-icons';
import React, { useEffect, useState } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { useTheme } from 'react-native-paper';

import { OEText, OETouchableOpacity } from '../../atoms';
import {
  bc,
  flex,
  height,
  mh,
  ml,
  mr,
  mt,
  mv,
  rounded,
  width,
} from '../../style-utils';

export interface PanelSliderProps {
  children: (currentIndex: number) => React.ReactNode;
  size: number;
}

// TODO: convert to styled-component
const PanelSlider = ({ children, size }: PanelSliderProps) => {
  const [current, setCurrent] = useState<number | null>(null);
  const canGoNext = current !== null && current + 1 < size;
  const canGoBack = current !== null && current > 0;

  useEffect(() => {
    if (size > 0) {
      setCurrent(0);
    } else {
      setCurrent(null);
    }
  }, [size]);

  const nextSlide = () => {
    if (!canGoNext || current === null) return;
    setCurrent(current + 1);
  };

  const backSlide = () => {
    if (!canGoBack || current === null) return;
    setCurrent(current - 1);
  };

  const handleIndexChange = (current: number) => {
    setCurrent(current);
  };

  if (current === null) return null;
  return (
    <View>
      <View
        style={[
          flex('flex-row', 'justify-content-between', 'align-items-center'),
        ]}
      >
        <ArrowButton
          onPress={backSlide}
          name="chevron-left"
          canGo={canGoBack}
          style={mr(24)}
        />

        {current >= size ? null : children(current)}

        <ArrowButton
          onPress={nextSlide}
          name="chevron-right"
          canGo={canGoNext}
          style={ml(24)}
        />
      </View>
      <View>
        {(canGoBack || canGoNext) && (
          <PanelSliderBottom
            size={size}
            onIndexChange={handleIndexChange}
            current={current}
          />
        )}
      </View>
    </View>
  );
};

type ArrowButtonProps = {
  onPress: () => void;
  name: string;
  canGo: boolean;
  style?: StyleProp<ViewStyle>;
};

const ArrowButton: React.FC<ArrowButtonProps> = ({
  onPress,
  name,
  canGo,
  style,
}) => (
  <OETouchableOpacity onPress={onPress} style={style}>
    <OEText fontSize={16}>
      {canGo ? (
        <FontAwesome5 name={name} size={16} />
      ) : (
        <View style={width(10)} />
      )}
    </OEText>
  </OETouchableOpacity>
);

interface PanelSliderBottomProps {
  onIndexChange: (index: number) => void;
  size: number;
  current: number;
}

const PanelSliderBottom = ({
  onIndexChange,
  size,
  current,
}: PanelSliderBottomProps) => {
  const { colors } = useTheme();
  const sliderIndexes: number[] = [];
  for (let index = 0; index < size; index++) {
    sliderIndexes.push(index);
  }
  return (
    <View style={[flex('flex-row', 'justify-content-center'), mt(16)]}>
      {sliderIndexes.map((actual) => {
        return (
          <OETouchableOpacity
            key={actual}
            style={[
              width(8),
              height(8),
              rounded(4),
              mh(4),
              mv(8),
              bc(current === actual ? colors.primary : colors.border),
            ]}
            onPress={() => onIndexChange(actual)}
          />
        );
      })}
    </View>
  );
};

export default PanelSlider;
